import { defineComponent, h, useAttrs } from 'vue'
import { VTooltip } from 'vuetify/components'

function isEventKey(key) {
  return /^on[A-Z]/.test(key)
}

function splitActivatorProps(props = {}) {
  const attrs = {}
  const on = {}

  Object.entries(props).forEach(([key, value]) => {
    if (isEventKey(key)) {
      on[key.slice(2).toLowerCase()] = value
    } else {
      attrs[key] = value
    }
  })

  return { attrs, on }
}

export default defineComponent({
  name: 'VTooltipCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(VTooltip, attrs, {
        ...slots,
        activator: slots.activator
          ? (scope) => {
              const { attrs: legacyAttrs, on } = splitActivatorProps(
                scope?.props || {}
              )

              return slots.activator({
                ...scope,
                attrs: legacyAttrs,
                on
              })
            }
          : undefined
      })
  }
})
